// extracted by mini-css-extract-plugin
module.exports = {"date":"questionDate_date__0lLNF"};